import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthService } from '@appShared/services/auth.service';
import { SiteService } from '@appShared/services/site.service';
import { AppActions } from '@appState/actions';

@Injectable()
export class AppEffects {
  constructor(
    private _actions$: Actions,
    private _authService: AuthService,
    private _siteService: SiteService) { }

  loadSiteConfig$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(AppActions.loadSiteConfig),
      switchMap(action =>
        this._authService.getSiteConfig().pipe(
          switchMap(siteConfig => {
            const actions = [];

            // const profile = siteConfig?.userProfile;
            // const selectedEmployeeProfile = profile?.dealerInfo ? profile : null
            /* add setSelectedDealer IF userProfile is a dealer */
            // if (selectedEmployeeProfile) {
            //  actions.push(ShareholderPageActions.setSelectedShareholder({ profile: profile }))
            // }

            actions.push(AppActions.loadSiteConfigSuccess({ siteConfig }));

            return actions;
          }),
          catchError(error => of(AppActions.loadSiteConfigFailure({ error })))
        )
      )
    );
  });

  toggleSiteOffline$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(AppActions.toggleIsAdminOnlyMode),
      switchMap(action =>
        this._siteService.toggleIsAdminOnlyMode(action.isAdminOnlyMode).pipe(
          switchMap(isAdminOnlyMode => {
            const actions = [];

            actions.push(AppActions.toggleIsAdminOnlyModeSuccess({ isAdminOnlyMode }));

            return actions;
          }),
          catchError(error => of(AppActions.loadSiteConfigFailure({ error })))
        )
      )
    );
  });
}
